import styled, {css} from "styled-components";

const ContentContainerStyled = styled.div`
  padding: 3.2rem 1.6rem;
  ${props =>
        props.isBackup &&
        css`
           padding-top: 0;
           padding-bottom: 3.2rem;
        `}
  max-width: 120rem;

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    padding: 3.2rem 4.8rem;
  }
`;

export { ContentContainerStyled };